"use client";

import { Tabs } from "@zapier/design-system";
import { usePathname, useRouter } from "next/navigation";
import { useTranslations } from "next-intl";
import styles from "./TemplatesTabs.module.css";
import { useSessionContext } from "src/contexts/SessionContext";
import classNames from "classnames";

/**
 * Tab navigation for templates pages.
 *
 * Shows "Browse" and "Saved" tabs when user is logged in.
 */
export const TemplatesTabs = () => {
  const { session } = useSessionContext();
  const pathname = usePathname() || "/templates";
  const router = useRouter();
  const t = useTranslations("TemplatesTabs");

  const items = [
    { label: t("browse"), text: t("browse"), href: "/templates" },
    { label: t("saved"), text: t("saved"), href: "/templates/saved" },
  ];

  return (
    <div
      className={classNames(styles.tabContainer, {
        [styles.active]: session.is_logged_in,
      })}
    >
      {session.is_logged_in && (
        <Tabs
          items={items}
          selectedItemHref={pathname}
          shouldRenderTrack={false}
          onChooseItem={(item, e) => {
            if ("preventDefault" in e) {
              e.preventDefault();
              e.stopPropagation();
            }
            router.push(item.href);
          }}
        />
      )}
    </div>
  );
};
